import { Option } from './option';
import { AbstractGroup } from './abstract-group';
import { Logger } from './utilities/logger';
/**
 * Default consent option group, meaning it contains consent options which can be enabled or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Group extends AbstractGroup {
    constructor(api, data) {
        super(api, data);
        this.options = {};
        Logger.debug('group', `Starting to construct "${this.uid}".`);
        for (const identifier in data.options) {
            this.options[identifier] = new Option(this.api, this, data.options[identifier]);
        }
        Logger.debug('group', `Finished constructing "${this.uid}".`);
    }
    /**
     * Enabled or disables all consent options of this group. This will also automatically trigger the decoding of
     * corresponding content.
     *
     * @param {boolean} enabled True to enable all options, otherwise false
     */
    setOptionsEnabled(enabled) {
        for (const identifier in this.options) {
            const option = this.options[identifier];
            option.setEnabled(enabled);
        }
    }
    /**
     * Decodes all consent options of this group.
     *
     * @returns {Promise<void>[]} All promises for decoding options; may be empty, if decoding was not allowed or possible
     */
    decodeOptions() {
        const decodePromises = [];
        for (const identifier in this.options) {
            const option = this.options[identifier];
            decodePromises.push(...option.decode());
        }
        return decodePromises;
    }
}
